<script setup lang="ts">
import { ref, watch } from 'vue'
import i18n from '@/lang/i18n';

const ERROR_KEY_PREFIX = 'initial_params.etc';
const SELECT_ITEM_ETC_CONNECT =[
  {title: 'ON', value: 'ON'},
  {title: 'OFF', value: 'OFF'},
]
const SELECT_ITEM_ETC_DEVICE =[
  {title: 'FURUNO', value: 'FURUNO'},
  {title: 'DENSO', value: 'DENSO'},
  {title: 'MITSUBISHI', value: 'MITSUBISHI'},
]
const SELECT_ITEM_ETC_ROAD_SELECT =[
  {title: 'ON', value: 'AUTO'},
  {title: 'OFF', value: 'MANUAL'},
]
const props = defineProps(['modelValue','isOperationOffice', 'errors','isInstallationOffice']);
const emit = defineEmits(['update:modelValue']);

const form = ref(props.modelValue)

watch(props, () => {
  form.value = props.modelValue
}, { deep: true })
watch(form, () => {
  emit('update:modelValue', form.value)
}, { deep: true })
</script>

<style scoped>
.headline {
  font-size: 24px;
  font-weight: bold;
  color: #0088a6;
}
</style>

<template>
  <v-card class="my-4 pa-4">
    <v-card-title class="headline">
      {{ i18n.global.t('pages.vehicles.form.iniFileSetting.etc.title') }}
    </v-card-title>
    <v-card-text>
      <div class="row mr-3 pb-0" v-show="!isOperationOffice">
        <div class="col-6">
          <v-select
            hide-details="auto"
            class="small mt-2"
            :label="i18n.global.t('pages.vehicles.form.iniFileSetting.etc.connect')"
            v-model="form.connect"
            :items="SELECT_ITEM_ETC_CONNECT"
            :error-messages="errors[ERROR_KEY_PREFIX+'.connect']"
            :clearable="false"
          >
          </v-select>
        </div>
        <div class="col-6">
          <v-select
            hide-details="auto"
            class="small mt-2"
            :label="i18n.global.t('pages.vehicles.form.iniFileSetting.etc.device')"
            v-model="form.device"
            :items="SELECT_ITEM_ETC_DEVICE"
            :error-messages="errors[ERROR_KEY_PREFIX+'.device']"
            :clearable="false"
            :disabled="isInstallationOffice"
          >
          </v-select>
        </div>
      </div>
      <div class="row mr-3 pb-0 pt-0">
        <div class="col-6">
          <v-select
            hide-details="auto"
            class="small mt-2"
            :label="i18n.global.t('pages.vehicles.form.iniFileSetting.etc.roadSelect')"
            v-model="form.road_select"
            :items="SELECT_ITEM_ETC_ROAD_SELECT"
            :error-messages="errors[ERROR_KEY_PREFIX+'.road_select']"
            :clearable="false"
            :disabled="isInstallationOffice"
          >
          </v-select>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
